export const sources={avif:"__VITE_ASSET__D8rubGBG__ 20w"};export const img={src:"__VITE_ASSET__DqagT7QQ__",w:20,h:20};export default{sources:sources,img:img};